var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_c('PageHeader', [_c('PageHeaderTitleContent', [_c('TitleTextContent', {
    attrs: {
      "titleText": 'Speaker Request'
    }
  })], 1)], 1), _vm._m(0)], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "section contact-area"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-lg-12 col-12"
  }, [_c('div', {
    staticClass: "section-title"
  }), _c('div', {
    staticClass: "contact-address mt-5"
  }, [_c('h2', {
    staticClass: "text-black text-center"
  }, [_vm._v("Request a Project Spectrum Speaker for Your Event")])]), _c('div', {
    staticClass: "mt-5"
  }, [_c('iframe', {
    staticStyle: {
      "border": "none",
      "max-width": "100%",
      "max-height": "100vh"
    },
    attrs: {
      "data-v-0af444d8": "",
      "allowfullscreen": "allowfullscreen",
      "frameborder": "0",
      "height": "1200px",
      "marginheight": "0",
      "marginwidth": "0",
      "mozallowfullscreen": "",
      "msallowfullscreen": "",
      "src": "https://forms.osi.apps.mil/Pages/ResponsePage.aspx?id=kQEtEK7uYUexyxqD6G70ReVoSueRHttHk2hx5nY_txpUQVMyUklMNlVMNExPU1lVRDNSU1dDT0ZUSiQlQCN0PWcu&embed=true",
      "webkitallowfullscreen": "",
      "width": "1200px",
      "data-sleek-frame-id": "5b3ed513-7909-42c5-b083-be8243089119"
    }
  })])])])])]);

}]

export { render, staticRenderFns }